
const products = [
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini%2520Banner%2520%25286%2529-0a3668c2-8ab7-4a51-8d10-06661d91b5e3.png&w=1920&q=75',
    title: "TEC Community Cup - Spectre Divide",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "UPCOMING",
    date: "6 Oct 2024",
    link: "/xyz-tro-123" , 
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain%2520Banner%2520%25285%2529-e91d87cb-2c1d-40af-9a61-eb611809b0b9.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Spectre',
    teamsize:'3+1',
    prize:'1,00,000 INR',
    format:'Single Elimination',
    registerstart:'September 16th 24, 3:39 pm',
    registerend:'September 28th 24, 6:00 pm',
    tournamentstart:'September 29th 24, 3:09 pm',
    tournamentend:'October 13th 24, 3:16 pm'
    ,id:"7"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FWEBSITE-BANNER-%25282%2529Mini-Banner-2ac2136e-a7be-4479-ab35-70e2b1880e69.png&w=1920&q=75',
    title: "Alienware Gaming Saturdays - Indore",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "UPCOMING",
    date: "6 Oct 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FWEBSITE-BANNER-%25282%2529Main-Banner-7d38a669-307c-4dd6-9bf8-0d729332fac1.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' Valorant',
    teamsize:'2-0',
    prize:'20,00,000 INR',
    format:'Single Elimination',
    registerstart:'September 18th 24, 12:00 pm',
    registerend:'September 21st 24, 1:30 pm',
    tournamentstart:'September 21st 24, 1:45 pm',
    tournamentend:'September 21st 24, 6:00 pm'
    ,id:"8"
  },
  {
    imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini-Banner%2520%252810%2529-1485bf80-8ce5-4bcb-b0ca-118bb2594536.png&w=1920&q=75',
    title: "Intel Gamer Days - Lenovo, BIT Pilani Hyderabad Campus(EA FC 24)",
    mode: 'Game Mode: Single Elimination',
    platform: 'Platform:',
    prize: "100000000",
    participants: "8 of 128",
    status: "UPCOMING",
    date: "6 Oct 2024",
    link: "/xyz-tro-123",
    country:"Countries",
    bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain-Banner%2520%252812%2529-c36c4ea4-a0b9-48ab-8bc4-65a0399956a3.png&w=1920&q=75',
    tourend:'Tournament ends in 1 day',
    tourhost:'Hosted by ',
    game:' FC24',
    teamsize:'NA',
    prize:'1,00,000 INR',
    format:'Single Elimination',
    registerstart:'September 15th 24, 4:30 pm',
    registerend:'September 22nd 24, 10:30 am',
    tournamentstart:'September 22nd 24, 11:00 am',
    tournamentend:'September 22nd 24, 6:00 pm'
    ,id:"9"
  },
  {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FWEBSITE-BANNER-%25282%2529Mini-Banner-a125aa48-1904-43d7-ae13-4179fddcfb9c.png&w=1920&q=75',
      title: "Alienware Gaming Saturdays - Hubli",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "UPCOMING",
      date: "6 Oct 2024",
      link: "/xyz-tro-123",
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FWEBSITE-BANNER-%25282%2529Main-Banner-1b480984-4410-4038-b79a-c4682d956026.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' Valorant TDM ',
      teamsize:'NA',
      prize:'40,000 INR Worths of Amazon Vouchers',
      format:'Double Elimination',
      registerstart:'September 18th 24, 12:00 pm',
      registerend:'September 21st 24, 1:30 pm',
      tournamentstart:'September 21st 24, 1:45 pm',
      tournamentend:'September 21st 24, 6:00 pm'
      ,id:"10"

    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMini-Banner%2520%25284%2529-7c776273-9a6e-4e7e-9ae7-a6dd9f5f8deb.png&w=1920&q=75',
      title: "Intel Gamer Days - Lenovo, MIT World Peace University (MK1)",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "10,000 INR",
      participants: "8 of 128",
      status: "UPCOMING",
      date: "6 Oct 2024",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FMain-Banner%2520%25286%2529-f1f020e0-27c8-4aaa-ae4b-224a11dcb20b.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:'  EAFC24(1v1)',
      teamsize:'NA',
      prize:'10,000 INR',
      format:'Single Elimination',
      registerstart:'September 12th 24, 10:45 am',
      registerend:'September 16th 24, 1:30 pm',
      tournamentstart:'September 16th 24, 1:45 pm',
      tournamentend:'September 16th 24, 6:00 pm'
      ,id:"11"
    },
    {
      imgUrl: 'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FSMALL%2520banner-32c249e3-512f-4109-b464-55a80dded1c6.png&w=1920&q=75',
      title: "TEC Gauntlet Season 3 - PUBG PC",
      mode: 'Game Mode: Single Elimination',
      platform: 'Platform:',
      prize: "100000000",
      participants: "8 of 128",
      status: "ONGOING",
      date: "6 Oct 2024",
      link: "/xyz-tro-123" ,
      country:"Countries",
      bannerUrl:'https://theesports.club/_next/image?url=https%3A%2F%2Fcdn.theesports.club%2FBIG%2520banner%2520%25282%2529-3ab34805-7d0e-471d-b6fc-59fcfaf70d94.png&w=1920&q=75',
      tourend:'Tournament ends in 1 day',
      tourhost:'Hosted by ',
      game:' BattleGROUNDS ',
      teamsize:'NA',
      prize:'1,00,000 INR',
      format:'Battle Royale',
      registerstart:'September 7th 24, 6:45 pm',
      registerend:'September 30th 24, 10:46 am',
      tournamentstart:'October 1st 24, 10:46 am',
      tournamentend:'October 8th 24, 10:46 am'
      ,id:"12"
    }

];

export{
  products
}